import useSWR from 'swr';

import apiRequest from '@/services/apiRequest';
import { getCoreApi } from '@/utility/getCoreApi';

export type TPopularUpcomingDates = {
  title: string;
  image: string;
  active_listing_count: number;
  booking_count: number;
  dates: {
    from: string;
    to: string;
  };
};

export const usePopularUpcomingDates = (locale: string = 'en-us') => {
  const { data: allDates, error } = useSWR<TPopularUpcomingDates[]>(
    locale === 'en-us' ? `${getCoreApi()}/widget/booked-dates` : null,
    url =>
      apiRequest({
        method: 'GET',
        url,
      }),
    {
      revalidateOnFocus: false,
    },
  );

  const currentDate = new Date().toISOString().split('T')[0] || '';

  const data = allDates?.filter(item => item.dates.from >= currentDate).slice(0, 3) ?? [];

  return { data, error };
};
